import angular from 'angular';
import moment from 'moment';

//This filter gets a number of minutes and formats it to 'hh:mm' format.
angular.module('commonServices').filter('timespanToDate', function() {
  var timeRegex = /^(0?[0-9]|1[0-9]|2[0-3]):([0-5]?[0-9])(?::([0-5]?[0-9]))?$/;
  return function(value) {
    if (!value) return null;
    var m = value.match(timeRegex);
    if (!m) return null;
    return moment()
      .startOf('day')
      .set({
        hour: parseInt(m[1]) || 0,
        minute: parseInt(m[2]) || 0,
        second: parseInt(m[3]) || 0,
      })
      .toDate();
  };
});
